import { gql } from '@apollo/client';

export const LIST_CLINICIANS_QUERY = gql`
  query listClinicians($clinicIds: [ID!]) {
    listClinicians(clinicIds: $clinicIds) {
      id
      name
      email
      clinicId
    }
  }
`;
